module.exports = __webpack_public_path__ + "img/图片8.cafe353c.png";